import { Box, Typography } from "@mui/material";
import { compose } from "redux";
import ambassadorHOC from "../../../ambassadors/ambassador-hoc";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClientAmbassadorMasterList from "./ambassador-list";
import ClientCriteriaAmbassador from "./client-criteria-ambassador";
import ClientSuggestedAmbassadors from "./suggested-ambassadors";

function ClientAmbassadors() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            background: "#070639",
            color: "white",
          }}
        >
          <Typography>Ambassador Based on criteria</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ClientCriteriaAmbassador />
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          aria-controls="select-ambassadors-content"
          id="select-ambassadors-header"
          sx={{
            background: "#070639",
            color: "white",
          }}
        >
          <Typography>Select Ambassadors</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ClientAmbassadorMasterList />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          aria-controls="suggested-ambassadors-content"
          id="suggested-ambassadors-header"
          sx={{
            background: "#070639",
            color: "white",
          }}
        >
          <Box>
            <Typography>Initiative Match</Typography>
            <Typography fontSize={12} sx={{ opacity: 0.85, mt: 0.25 }}>
              Suggested ambassadors based on this client&apos;s value props and each
              ambassador&apos;s initiatives. Select any to add to the client&apos;s
              target list.
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <ClientSuggestedAmbassadors />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default compose(ambassadorHOC)(ClientAmbassadors);
